/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import ReactPlayer from 'react-player';
import moment from 'moment';
import ARTIST_DETAILS_QUERY from '../../../graphql/ArtistDetails';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import TextSection from '../../../components/TextSection/index';
import Carousel from '../../../components/Carousel/index';
import ContactArtistForm from '../../Others/ContactArtistForm';
import KeyToProfession from '../../../transforms/KeyToProfession';
import IsGuest from '../../../utils/IsGuest';
import ToggleArtistFavorite from '../../Others/ToggleArtistFavorite';
import Authorization from '../../../components/Authorization';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE } from '../../../constants';
import { WorkExperienceBox } from '../../../components/WorkExperience';
import { TitleYearsBox } from '../../../components/TitleYears';
import SocialBanner from './SocialBanner';


class ArtistPage extends Component {
  render() {
    let { artist } = this.props;

    if (!artist) {
      artist = {};
    }

    const isFull = (this.props.artist ? this.props.artist.infoType === 'full' : false);

    return (
      <div>
        <Banner />
        <div className="properties-details-page artist-page">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="properties-details-section">
                  <div className="clearfix m-b-lg m-l-sm">
                    <div className="pull-left">
                      <h3>
                        <i className="fa fa-user" aria-hidden="true" />
                        &nbsp; {artist.name} {artist.lastname}
                      </h3>
                    </div>
                    {(!IsGuest() && artist && artist.id) && (
                      <div className="pull-right">
                        <div className="favorites__wrapper">
                          <ToggleArtistFavorite id={artist.id} favorite={artist.favorite} />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="pull-right col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div className="col-md-12">
                      <SocialBanner artist={artist} />
                      <Carousel id="artist-images" images={artist.images} />

                      {isFull && artist.videos && (
                        <div className="video-gallery">
                          {artist.videos.map(v => (
                            <div key={v.url} className="video-item">
                              <ReactPlayer
                                controls
                                url={v.url}
                                width="100%"
                                height="100%"
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {isFull && artist && artist.id && (
                      <div className="col-md-12 mt-20">
                        <ContactArtistForm id={artist.id} />
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div className="properties-condition">
                      <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-12">
                          <ul className="condition">
                            <li>
                              <i className="fa fa-address-card" />
                              {KeyToProfession(artist.profession)}
                            </li>
                            <li>
                              <i className="fa fa-check" />
                              {artist.specialty}
                            </li>
                            {artist.showAge && artist.birthday && (
                              <li>
                                <i className="fa fa-birthday-cake" />
                                {moment().diff(artist.birthday, 'years')} años
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                          <ul className="condition">
                            <li className="artist-nationality">
                              <i className="fa fa-flag" />
                              {artist.nationality}
                            </li>
                            {artist.residence && (
                              <li>
                                <i className="fa fa-home" />
                                {artist.residence}
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>

                    {artist.biography && (
                      <div className="row">
                        <div className="col-md-12">
                          <TextSection title="Reseña CV" content={artist.biography} />
                          {artist.cv && artist.cv.url && (
                            <div className="row cvfile">
                              <div className="col-md-12">
                                <Authorization allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
                                  <a target="_blank" rel="noopener noreferrer" href={artist.cv.url}>
                                    <i className="fa fa-file pr-5" aria-hidden="true" />
                                    Curriculum Vitae
                                  </a>
                                </Authorization>
                                <Authorization denied={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
                                  <span>
                                    <i className="fa fa-file pr-5" aria-hidden="true" />
                                    Curriculum Vitae
                                  </span>
                                </Authorization>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {isFull && artist.agency && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="properties-condition mrg-btm-40 ">
                            <h5 className="heading">Agencia</h5>
                            <div className="agency">
                              <p><strong>Agencia:</strong> {artist.agency}</p>
                              {artist.agencyEmail && (
                                <p><strong>Correo electrónico:</strong> {artist.agencyEmail}</p>
                              )}
                              {artist.agencyWeb && (
                                <p><strong>Sitio Web:</strong> <a href={artist.agencyWeb} target="_blank">{artist.agencyWeb}</a></p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {isFull && artist.formal_education && artist.formal_education.length > 0 && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="properties-condition mrg-btm-40 ">
                            <h5 className="heading">Educación formal</h5>
                            <ul className="education">
                              {artist.formal_education.map((ed, index) => (
                                <TitleYearsBox key={index} {...ed} />
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {isFull && artist.informal_education && artist.informal_education.length > 0 && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="properties-condition mrg-btm-40 ">
                            <h5 className="heading">Educación informal</h5>
                            <ul className="education">
                              {artist.informal_education.map((ed, index) => (
                                <TitleYearsBox key={index} {...ed} />
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {isFull && artist.support && artist.support.length > 0 && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="properties-condition mrg-btm-40 ">
                            <h5 className="heading">Becas y apoyos</h5>
                            <ul className="education">
                              {artist.support.map((ed, index) => (
                                <TitleYearsBox key={index} {...ed} />
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {isFull && artist.achievements && artist.achievements.length > 0 && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="properties-condition mrg-btm-40 ">
                            <h5 className="heading">Reconocimientos</h5>
                            <ul className="education">
                              {artist.achievements.map((a, index) => (
                                <li key={index} className="education-item">{a.title} <span>{a.year}</span></li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {isFull && artist.clips && artist.clips.length > 0 && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="properties-condition mrg-btm-40 ">
                            <h5 className="heading">Recortes de prensa</h5>
                            <Carousel id="clips" images={artist.clips} />
                          </div>
                        </div>
                      </div>
                    )}

                    {isFull && artist.work_experience && artist.work_experience.length > 0 && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="properties-condition mrg-btm-40 ">
                            <h5 className="heading">Experiencia de trabajo</h5>
                            <ul className="work-experience__list">
                              {artist.work_experience.map((w, index) => (
                                <WorkExperienceBox key={index} {...w} />
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                  <div className="clearfix" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withDetails = graphql(ARTIST_DETAILS_QUERY, {
  options: ({ match }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      slug: match.params.artistSlug,
    },
  }),
  props: ({ data }) => ({
    loading: data.loading,
    artist: data.artist,
  }),
});

export default withDetails(ArtistPage);



// WEBPACK FOOTER //
// ./src/containers/General/ArtistPage/index.js